// YUH theme — header interactions
document.addEventListener('DOMContentLoaded', function () {
  function setupToggle(buttonSelector, panelId) {
    var btn = document.querySelector(buttonSelector);
    var panel = document.getElementById(panelId);
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  setupToggle('.search-toggle', 'HeaderSearch');
  setupToggle('.menu-toggle', 'MobileMenu');

  // close search bar automatically once mobile menu opens, and vice versa
  var search = document.getElementById('HeaderSearch');
  var menu = document.getElementById('MobileMenu');
  var searchBtn = document.querySelector('.search-toggle');
  var menuBtn = document.querySelector('.menu-toggle');

  if (menuBtn && search) {
    menuBtn.addEventListener('click', function () {
      if (!menu.hidden && !search.hidden) {
        search.hidden = true;
        if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }
  if (searchBtn && menu) {
    searchBtn.addEventListener('click', function () {
      if (!search.hidden && !menu.hidden) {
        menu.hidden = true;
        if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
